import React, { Component } from "react";
import { AreaOnlySeries } from "./AreaOnlySeries";
import { LineSeries } from "./LineSeries";
/**
 * `AreaSeries` component
 */
export class AreaSeries extends Component {
    render() {
        const { baseAt, className, opacity, stroke, strokeWidth, strokeOpacity, strokeDasharray, canvasGradient, fill, interpolation, style, canvasClip, yAccessor, } = this.props;
        return (React.createElement("g", { className: className },
            React.createElement(AreaOnlySeries, { yAccessor: yAccessor, interpolation: interpolation, base: baseAt, canvasGradient: canvasGradient, fill: fill, opacity: opacity, style: style, canvasClip: canvasClip, stroke: "none" }),
            React.createElement(LineSeries, { yAccessor: yAccessor, stroke: stroke, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, strokeDasharray: strokeDasharray, interpolation: interpolation, style: style, canvasClip: canvasClip, fill: "none", highlightOnHover: false })));
    }
}
AreaSeries.defaultProps = {
    className: "react-financial-charts-area",
    fill: "#2196f3",
    opacity: 0.1,
    stroke: "#2196f3",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeDasharray: "Solid",
};
//# sourceMappingURL=AreaSeries.js.map